import React from 'react';
import Select from 'react-select';

const Sort = props => {
  const sortFileds = [
    { label: locales('fields.createdAt'), value: 'createdAt' },
    { label: locales('labels.score'), value: 'score' },
    { label: locales('fields.cafe.name'), value: 'cafeName' },
    { label: locales('labels.last.reviewed.at'), value: 'lastReviewedAt' }
  ];

  return (
    <div className="col-12 d-flex align-items-center my-3">
      <Select
        placeholder={locales('messages.sortBy')}
        isMulti={false}
        name="sort"
        value={props.selectedSortFiled}
        options={sortFileds}
        onChange={props.onChangeSortBy}
        className="w-25"
      />
      <label className="mx-2">
        {locales('tables.desc')}
        <input
          type="radio"
          name="sortType"
          className="mx-2"
          onChange={e => props.setSortDirection('desc')}
          checked={props.sortDirection == 'desc'}
        />
      </label>
      <label className="mx-2">
        {locales('tables.asc')}
        <input
          type="radio"
          name="sortType"
          className="mx-2"
          onChange={e => props.setSortDirection('asc')}
          checked={props.sortDirection == 'asc'}
        />
      </label>
      <button
        disabled={!props.selectedSortFiled}
        onClick={props.onSort}
        className="btn btn-primary"
      >
        {locales('tables.sortIt')}
      </button>
    </div>
  );
};

export default Sort;
